import Vue from "vue";
import Vuex from "vuex";
import products from "./productList/products";
import breadcrumbs from "./productList/breadcrumbs";
import recruitment from "./recruitment/recruitment";
import configurableProducts from "./configurableProducts/configurableProducts";
import SalePromoters from "./SalePromoters/SalePromoters";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    windowWidth: window.innerWidth,
  },
  mutations: {
    setWindowWidth(state) {
      state.windowWidth = window.innerWidth;
    },
  },
  actions: {},
  modules: {
    products: products,
    breadcrumbs: breadcrumbs,
    recruitment: recruitment,
    configurableProducts: configurableProducts,
    SalePromoters: SalePromoters,
  },
  strict: process.env.NODE_ENV !== "production",
});
